import { Row, Col } from "reactstrap";

// components
import NonAuthLayoutWrapper from "../../components/NonAutnLayoutWrapper";
import withRouter from "../../components/withRouter";

const LogoutTest = (props: any) => {
  return (
    <NonAuthLayoutWrapper>
      <Row className="justify-content-center my-auto">
          <Col className="text-secondary align-center text-center">
            <span style={{ fontSize: "60px" }}>ℹ️</span><br />
            This page longer valid, <a href="/dashboard">ไปหน้าหลัก</a>
          </Col>
      </Row>
    </NonAuthLayoutWrapper>
  );
};

export default withRouter(LogoutTest);
